export const applicationId = 'c712b0e1-0a5f-47f3-9fbf-91e1dd89b0cf';
export const UNO_URL = 'https://api.simulanis.io';